// extracted by mini-css-extract-plugin
export default {"root":"UserManage_root__nf1E5"};